import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
  .hide-content{
    display: none;
  }
  .accordion-button:focus{
    outline: -webkit-focus-ring-color auto 1px !important;
  }
  .accordion-item {
    border: 0px solid hsla(0,0%,76.9%,.125);
  }
  .property-details-component{
    scroll-margin-top: ${toRem(136)};
    margin: auto;
    max-width: ${toRem(1440)};
    background-color: ${theme.color['white']};
    padding: ${toRem(18)} ${toRem(158)} ${toRem(16)};
    font-family: ${theme.fonts['fontFamilySwiss']};
    .component-heading{
      margin-bottom: ${toRem(24)};
      &::before{
        display: block;
        content: " ";
        margin-top: ${toRem(-154)};
        height: ${toRem(154)};
        visibility: hidden;
        pointer-events: none;
      }
    }
    .component-content{
      justify-content: space-between;
      width: 66%;
      padding-bottom: ${toRem(17)};
      .accordian{
        color: ${theme.color['black']};
        .accordian-title{
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          padding: 0;

          p {
            margin-bottom: 0;
          }
        }
        .add-border{
          border-bottom: ${toRem(1)} solid ${theme.color['alto']};
          margin-top: ${toRem(16)};
          margin-bottom: ${toRem(20)};
        }
        .accordian-content{
          margin-top: ${toRem(35)};
          .accessibility-note{
            padding: 0;
            margin-bottom: ${toRem(56)};
          }
          .subheading-title{
            margin-bottom: ${toRem(10)};
          }
          .subheading-content{
            margin-bottom: ${toRem(55)};
            .accessibility-item{
              margin-bottom: ${toRem(16)};
            }
          }
        }
      }
    }
    .component-content>*{
      flex-basis: 100%;
      flex-grow: 0;
    }
    .component-content-small-screen{
      display: none;
    }
  }
  .space-buffer{
    scroll-margin-top: ${toRem(245)};
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .property-details-component{
      margin-top: ${toRem(-150)};
      padding-top: ${toRem(150)};
    }
    .space-buffer{
      margin-top: ${toRem(-275)};
      padding-top: ${toRem(275)};
    }
  }

  @media only ${theme.mediaQuery.allTablets} {
    .property-details-component{
      padding-left: ${toRem(32)};
      padding-right: ${toRem(32)};
    }
  }
  @media only ${theme.mediaQuery.smallerTablet} {
    .property-details-component{
      scroll-margin-top: ${toRem(30)};
      padding-left: ${toRem(32)};
      padding-right: ${toRem(32)};
      padding-top: ${toRem(15)};
      .component-heading{
        margin-bottom: ${toRem(24)};
      }
      .component-content{
        width: 100%;
        .accordian{
          .accordian-title{
          }
          .accordian-content{
            .accessibility-note{
            }
            .subheading-title{
            }
            .subheading-content{
              .accessibility-item{
              }
            }
          }
        }
      }
    }
    .space-buffer{
      scroll-margin-top: ${toRem(80)};
    }
  }
  @media only ${theme.mediaQuery.allMobiles} {
    .property-details-component{
      scroll-margin-top: ${toRem(30)};
      padding: ${toRem(22)} ${toRem(16)} ${toRem(20)};
      .component-heading{
        margin-bottom: ${toRem(11)};
      }
      .component-content{
        width: 100%;
        .accordian{
          .accordian-title{
          }
          .accordian-content{
            .accessibility-note{
            }
            .subheading-title{
            }
            .subheading-content{
              .accessibility-item{
              }
            }
          }
        }
      }
    }
  }
  .hqv-modal {
    &.property-details-component{
      scroll-margin-top: ${toRem(30)};
      padding-left: ${toRem(24)};
      padding-right: ${toRem(24)};
      padding-top: ${toRem(15)};
      @media only ${theme.mediaQuery.allMobiles} {
        padding: 0;
        margin-left: ${toRem(16)};
        margin-right: ${toRem(16)};
      }
      .component-heading{
        margin-bottom: ${toRem(24)};
      }
      .component-content{
        width: 100%;
        .accordian{
          .accordian-title{
          }
          .accordian-content{
            .accessibility-note{
            }
            .subheading-title{
            }
            .subheading-content{
              .accessibility-item{
              }
            }
          }
        }
      }
    }
    &.space-buffer{
      scroll-margin-top: ${toRem(80)};
    }
  }`}
`;
